import React from 'react';
import { Link } from 'react-router-dom';
export const QualitySection = () => {
  const benefits = [{
    icon: <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1444">
          <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1445" />
          <path d="M7.5 12H16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1446" />
          <path d="M12 7.5V16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1447" />
        </svg>,
    title: 'Maatwerk uit eigen fabriek',
    description: 'Vakkundig ontworpen en geproduceerd volgens uw exacte specificaties en wensen.'
  }, {
    icon: <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1448">
          <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1449" />
          <path d="M12 7V12L15 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1450" />
        </svg>,
    title: 'Snelle levering',
    description: 'Dankzij onze eigen productiefaciliteit garanderen wij kortere levertijden dan de industrie standaard.'
  }, {
    icon: <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1451">
          <path d="M20.5902 11.0001L12.0002 2.41006L3.41016 11.0001C2.63016 11.7801 2.63016 13.0301 3.41016 13.8101L12.0002 22.4101L20.5902 13.8201C21.3702 13.0401 21.3702 11.7801 20.5902 11.0001Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1452" />
          <path d="M16.25 11C16.25 13.8995 13.8995 16.25 11 16.25C8.10051 16.25 5.75 13.8995 5.75 11C5.75 8.10051 8.10051 5.75 11 5.75C13.8995 5.75 16.25 8.10051 16.25 11Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1453" />
        </svg>,
    title: 'Exclusieve prijsstelling',
    description: 'Transparante prijzen zonder verborgen kosten, direct van fabrikant naar klant zonder tussenpersonen.'
  }, {
    icon: <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1454">
          <path d="M20 7L9 18L4 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1455" />
        </svg>,
    title: 'Persoonlijke begeleiding',
    description: 'Onze ervaren adviseurs bieden exclusieve begeleiding en advies op maat voor uw specifieke situatie.'
  }];
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-1456">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiMzMjMyMzIiIGZpbGwtb3BhY2l0eT0iMC4wMiI+PHBhdGggZD0iTTM2IDM0aDR2MWgtNHYtMXptMC0yaDF2NGgtMXYtNHptMi0yaDF2MWgtMXYtMXptLTIgMmgtMXYtMWgxdjF6bS0yLTJoMXYxaC0xdi0xem0yLTJoMXYxaC0xdi0xem0tMiAydi0xaDF2MWgtMXptLTIgMGgtMXYtMWgxdjF6bS0yIDBoLTF2LTFoMXYxem0wIDJoLTF2LTFoMXYxem0wIDJoLTF2LTFoMXYxem0yIDBoMXYxaC0xdi0xem0yIDBoMXYxaC0xdi0xem0yIDBoMXYxaC0xdi0xeiIvPjwvZz48L2c+PC9zdmc+')] opacity-20" data-id="element-1457"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-1458">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start" data-id="element-1459">
          <div className="lg:col-span-5" data-id="element-1460">
            <div className="relative mb-12" data-id="element-1461">
              <div className="flex items-center mb-3" data-id="element-1462">
                <div className="w-12 h-[2px] bg-[#CDA735] mr-4" data-id="element-1463"></div>
                <span className="uppercase tracking-[0.2em] text-sm font-medium text-[#B89429]" data-id="element-1464">
                  Nederlands vakmanschap
                </span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-1465">
                Kwaliteit uit{' '}
                <span className="text-[#CDA735]" data-id="element-1466">eigen productie</span>
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-8 max-w-2xl" data-id="element-1467">
                Van ontwerp tot installatie, alles wordt in eigen beheer
                uitgevoerd door ons ervaren team van Nederlandse vakmensen.
              </p>
            </div>
            <div className="space-y-6 mb-10" data-id="element-1468">
              <p className="text-gray-700 text-lg leading-relaxed" data-id="element-1469">
                Wij geloven in{' '}
                <span className="font-medium text-[#B89429]" data-id="element-1470">
                  lokale productie
                </span>
                . In onze eigen Nederlandse fabriek produceren we alle veranda's
                en overkappingen volledig op maat.
              </p>
              <p className="text-gray-700 text-lg leading-relaxed" data-id="element-1471">
                Dit biedt u unieke voordelen: volledige controle over{' '}
                <span className="font-medium text-[#B89429]" data-id="element-1472">kwaliteit</span>,{' '}
                <span className="font-medium text-[#B89429]" data-id="element-1473">maatwerk</span> tot
                in detail, en{' '}
                <span className="font-medium text-[#B89429]" data-id="element-1474">
                  snelle levering
                </span>
                .
              </p>
              <p className="text-gray-700 text-lg leading-relaxed" data-id="element-1475">
                Door onze efficiënte productielijn kunnen we een veranda al
                binnen twee weken leveren en installeren. Zo kunt u snel
                genieten van uw nieuwe buitenruimte.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-5" data-id="element-1476">
              <Link to="/offerte-aanvragen" className="bg-[#CDA735] hover:bg-[#B89429] text-white font-medium px-8 py-3 rounded-md shadow-lg hover:shadow-[0_0_20px_rgba(205,167,53,0.3)] transition-all duration-300 text-center" data-id="element-1477">
                Offerte opvragen
              </Link>
              <Link to="/adviesgesprek" className="bg-white hover:bg-gray-50 text-[#B89429] font-medium px-8 py-3 rounded-md border border-gray-200 hover:border-[#CDA735] shadow-md hover:shadow-lg transition-all duration-300 text-center" data-id="element-1478">
                Plan een adviesgesprek
              </Link>
            </div>
          </div>
          <div className="lg:col-span-7" data-id="element-1479">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-1480">
              {benefits.map((benefit, index) => <div key={index} className="relative overflow-hidden group bg-white rounded-xl border border-gray-100 hover:border-[#CDA735]/30 transition-all duration-500 transform hover:-translate-y-1 hover:shadow-[0_15px_30px_rgba(0,0,0,0.05)]" data-id="element-1481">
                  <div className="absolute top-0 left-0 w-1 h-0 bg-[#CDA735] group-hover:h-full transition-all duration-500 ease-out" data-id="element-1482"></div>
                  <div className="p-8" data-id="element-1483">
                    <div className="flex items-start" data-id="element-1484">
                      <div className="mr-5 p-3 rounded-lg bg-gray-50 group-hover:bg-[#CDA735]/10 transition-all duration-300" data-id="element-1485">
                        <div className="text-[#CDA735] group-hover:text-[#B89429] transition-colors duration-300 transform group-hover:scale-110" data-id="element-1486">
                          {benefit.icon}
                        </div>
                      </div>
                      <div data-id="element-1487">
                        <h3 className="text-xl font-bold mb-3 text-gray-800 group-hover:text-[#CDA735] transition-colors duration-300" data-id="element-1488">
                          {benefit.title}
                        </h3>
                        <p className="text-gray-600 leading-relaxed" data-id="element-1489">
                          {benefit.description}
                        </p>
                      </div>
                    </div>
                    <div className="mt-6 pt-4 border-t border-gray-50 flex justify-end opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-1490">
                      <span className="text-sm font-medium text-[#CDA735] flex items-center" data-id="element-1491">
                        Meer informatie
                        <svg className="ml-2 w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-300" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1492">
                          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1493" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="mt-12 flex justify-end" data-id="element-1494">
              <div className="flex items-center bg-[#CDA735] text-white px-8 py-4 rounded-lg shadow-lg" data-id="element-1495">
                <div className="mr-4" data-id="element-1496">
                  <svg className="w-10 h-10 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-1497">
                    <path d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1498" />
                    <path d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1499" />
                  </svg>
                </div>
                <div data-id="element-1500">
                  <p className="text-sm uppercase tracking-wider font-light mb-1 text-white/90" data-id="element-1501">
                    Nederlandse kwaliteit
                  </p>
                  <p className="font-medium" data-id="element-1502">
                    10 jaar garantie op al onze producten
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};